const DpoCoreOdstoupeniOdZadosti = {
    init: function () {
        const tlacitko = $("#tlacitkoOdstoupitOdZadosti");
        if (!tlacitko.length) {
            return;
        }

        $(document)
            .on("modal.button.miniform.close.pre", function (e, data) {
                if (data.hasOwnProperty("miniformId")) {
                    if (110 === parseInt(data["miniformId"])) {
                        const duvod = $("#modal-duvododstoupeni").val();

                        let url = window.location.protocol + "//" + window.location.host;
                        url += "/ajax/core/odstoupeniOdZadosti";

                        const _ch = $("#_ch");
                        if (!_ch.length) {
                            return;
                        }

                        $.ajax({
                            type: "post",
                            url: url,
                            data: {"_ch": _ch.val(), "duvod": duvod},
                            dataType: "json",
                            global: true,
                            beforeSend: function () {
                                Lemo_Alert.closeAll();
                                Lemo_Alert.addInfo("Odstoupení od žádosti ...", "odstoupeniOdZadostiBeforeSend");
                            },
                            complete: function () {
                                Lemo_Alert.closeById("odstoupeniOdZadostiBeforeSend");
                            },
                            success: function (r) {
                                Lemo_Modal.close();
                                if (r.hasOwnProperty("messages")) {
                                    Lemo_Alert.addMany(r.messages);
                                }

                                setTimeout(function () {
                                    url = window.location.protocol + "//" + window.location.host;
                                    url += "/section/zadosti/item/"
                                    window.location = url;
                                }, 3000);
                            },
                            error: function () {
                                Lemo_Alert.addDanger("Odstoupení od žádosti selhalo.", "odstoupeniOdZadostiError");
                            }
                        });
                    }
                }
            });

    }
}

$(document).ready(function () {
    DpoCoreOdstoupeniOdZadosti.init();
});